import { Link, SupportingContent, Text, TextContainer } from "@wayflyer/flyui";
import { handleContactTeam } from "shared-utils";
import { FormattedMessage, useIntl } from "react-intl";

import { MESSAGES } from "./message-definitions";

export const ReviewScreenEmailVerificationBlockSecondaryContent = (): UIElement => {
  const intl = useIntl();
  return (
    <SupportingContent
      faqItems={[
        {
          question: intl.formatMessage(MESSAGES.emailVerificationTroubleTitle),
          answer: (
            <TextContainer>
              <FormattedMessage
                id="funding-application: email verification trouble details"
                defaultMessage={
                  "<p>If you have not received the verification email, please check your spam or junk folder. If the email is not there, please click on the button to try again. You'll need to wait 30 seconds in between attempts.</p>" +
                  "<p>If you continue to experience issues, please <a>contact our support team</a> for assistance.</p>"
                }
                values={{
                  p: (chunks: string) => <Text>{chunks}</Text>,
                  a: (chunks: string) => <Link onClick={handleContactTeam}>{chunks}</Link>,
                }}
              />
            </TextContainer>
          ),
        },
      ]}
    />
  );
};
